import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import SalesDashboard from "@/pages/SalesDashboard";
import VisitWorkspace from "@/pages/VisitWorkspace";
import OfficeDashboard from "@/pages/OfficeDashboard";
import OfficeReview from "@/pages/OfficeReview";
import ProjectMode from "@/pages/ProjectMode";
import AdminUsers from "@/pages/AdminUsers";

function RoleHome() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "office") return <Navigate to="/office" replace />;
  return <Navigate to="/dashboard" replace />;
}

function App() {
  return (
    <div className="App">
      <Toaster theme="dark" position="top-center" richColors closeButton />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<ProtectedRoute><RoleHome /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute roles={["salesperson"]}><SalesDashboard /></ProtectedRoute>} />
            <Route path="/visit/:projectId" element={<ProtectedRoute roles={["salesperson"]}><VisitWorkspace /></ProtectedRoute>} />
            <Route path="/project/:projectId" element={<ProtectedRoute roles={["salesperson"]}><ProjectMode /></ProtectedRoute>} />
            <Route path="/office" element={<ProtectedRoute roles={["office"]}><OfficeDashboard /></ProtectedRoute>} />
            <Route path="/office/:projectId" element={<ProtectedRoute roles={["office"]}><OfficeReview /></ProtectedRoute>} />
            <Route path="/admin/users" element={<ProtectedRoute roles={["admin"]}><AdminUsers /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
